(() => {
  function activate(root, id, focus) {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(tab => {
      const active = tab.dataset.tabTrigger === id;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    root.querySelectorAll('[data-tab-panel]').forEach(panel => { panel.hidden = panel.dataset.tabPanel !== id; });
  }
  function init(root) {
    if (root.dataset.tabsReady) return;
    root.dataset.tabsReady = 'true';
    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-tab-trigger]');
      if (tab && root.contains(tab)) activate(root, tab.dataset.tabTrigger, false);
    });
    root.addEventListener('keydown', event => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else return;
      event.preventDefault(); activate(root, tabs[index].dataset.tabTrigger, true);
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-tabbed-collections]').forEach(init); }
  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-tab-panel]');
    const root = event.target.closest('[data-tabbed-collections]');
    if (panel && root) activate(root, panel.dataset.tabPanel, false);
  });
})();
